import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import type { UniversalSearchResponse } from './search.types';
import { searchApi } from './searchApi';
import { useDebouncedValue } from './useDebouncedValue';

export function useUniversalSearch(initialQuery = '', companyId?: string, enabled = true) {
  const [query, setQuery] = useState(initialQuery);
  const debouncedQuery = useDebouncedValue(query.trim(), 180);

  const searchQuery = useQuery<UniversalSearchResponse>({
    // Include companyId in the key so results are not reused across companies.
    queryKey: ['universal-search', 'dropdown', debouncedQuery, companyId ?? 'none'],
    queryFn: () => searchApi.search({ q: debouncedQuery, mode: 'dropdown' }),
    enabled: enabled && debouncedQuery.length >= 2,
    staleTime: 30 * 1000,
  });

  return {
    query,
    setQuery,
    debouncedQuery,
    ...searchQuery,
  };
}
